/* CTG: make product-card images fill their (square) box without cropping the product.
   Display only: measures each image's built-in white/transparent margin and scales/centres
   the picture so the product's longest side reaches ~3% from the box edge. Never crops the
   product itself; photos without a plain white background are left untouched. */
(function () {
  var SEL = '.xo-product-card .xo-product-image img';
  var MARGIN = 0.03, MAX_SCALE = 5, N = 128;
  var cache = {};

  function key(src) { return (src || '').replace(/([?&])width=\d+&?/, '$1').replace(/^https?:/, ''); }

  function measure(src, cb) {
    var k = key(src);
    if (cache[k]) { if (cache[k].done) cb(cache[k].r); else cache[k].q.push(cb); return; }
    cache[k] = { done: false, q: [cb] };
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var r = null;
      try {
        var w = N, h = Math.max(1, Math.round(N * im.naturalHeight / im.naturalWidth));
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(im, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data;
        var isBg = function (i) { return d[i + 3] < 16 || (d[i] > 232 && d[i + 1] > 232 && d[i + 2] > 232); };
        var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
        var bgOk = corners.every(isBg);
        if (bgOk) {
          var x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
            if (!isBg((yy * w + xx) * 4)) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
          }
          var cr = 0, cg = 0, cb = 0, cn = 0;
          corners.forEach(function (i) { if (d[i + 3] >= 16) { cr += d[i]; cg += d[i + 1]; cb += d[i + 2]; cn++; } });
          var bg = cn === 4 ? 'rgb(' + Math.round(cr / 4) + ',' + Math.round(cg / 4) + ',' + Math.round(cb / 4) + ')' : '';
          if (x1 >= 0) r = { bg: bg, w: im.naturalWidth, h: im.naturalHeight, fx0: Math.max(0, (x0 - 1) / w), fx1: Math.min(1, (x1 + 2) / w), fy0: Math.max(0, (y0 - 1) / h), fy1: Math.min(1, (y1 + 2) / h) };
        }
      } catch (e) { r = null; }
      cache[k].done = true; cache[k].r = r;
      cache[k].q.forEach(function (f) { f(r); });
    };
    im.onerror = function () { cache[k].done = true; cache[k].r = null; cache[k].q.forEach(function (f) { f(null); }); };
    im.src = src;
  }

  function apply(img) {
    var src = img.currentSrc || img.src;
    if (!src || img.dataset.ctgFit === key(src)) return;
    img.dataset.ctgFit = key(src);
    measure(src, function (r) {
      if (!r) { img.classList.remove('ctg-fit'); return; }
      var W = img.clientWidth || 1, H = img.clientHeight || 1;
      var k = Math.min(W / r.w, H / r.h), dw = r.w * k, dh = r.h * k;
      var ox = (W - dw) / 2, oy = (H - dh) / 2;
      var pw = (r.fx1 - r.fx0) * dw, ph = (r.fy1 - r.fy0) * dh;
      var cx = ox + (r.fx0 + r.fx1) / 2 * dw, cy = oy + (r.fy0 + r.fy1) / 2 * dh;
      var s = Math.min(W * (1 - 2 * MARGIN) / pw, H * (1 - 2 * MARGIN) / ph, MAX_SCALE);
      if (!(s > 1.03)) { img.classList.remove('ctg-fit'); return; }
      var tx = -(cx - W / 2) * s, ty = -(cy - H / 2) * s;
      img.style.setProperty('--ctg-s', s.toFixed(3));
      img.style.setProperty('--ctg-tx', (tx / W * 100).toFixed(2) + '%');
      img.style.setProperty('--ctg-ty', (ty / H * 100).toFixed(2) + '%');
      img.classList.add('ctg-fit');
      var box = img.closest('.xo-image');
      if (box && r.bg && !img.closest('.xo-product-image__secondary')) box.style.backgroundColor = r.bg;
    });
  }

  function scan() { document.querySelectorAll(SEL).forEach(function (img) { if (img.complete && img.naturalWidth) apply(img); }); }
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && t.matches(SEL)) apply(t); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  new MutationObserver(function () { clearTimeout(scan.t); scan.t = setTimeout(scan, 200); }).observe(document.documentElement, { childList: true, subtree: true });
})();
